<app-fika-index-card-content [cardData]="data"></app-fika-index-card-content>
